import styles from "./styles.module.scss";
import "@cyntler/react-doc-viewer/dist/index.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { useContext, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Document, Page, pdfjs } from "react-pdf";

import { FileEditorComponentProps } from "./types";
import { FilesType } from "../../../forms/documents/types";
import { request } from "../../../../services";
import { useModals } from "../../file-menu/modal/utils/use-modals";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import { SessionContext } from "../../../../contexts/session/index.context";
import { SubSessionContext } from "../../../../contexts/session-sub/index.context";
import { useSignModal } from "../../../../contexts/sign-modal/index.context";
import IconKey from "../../../assets/key.png";
import IconSignKey from "../../../assets/sign-key.png";
//Components
import FileMenu from "../../file-menu";
import Popconfirm from "../../popconfirm-files";
// import Modal from "../file-menu/modal";
//UI
import Space from "antd/lib/space";
import Checkbox from "antd/lib/checkbox";
import Card from "antd/lib/card";
import Tooltip from "antd/lib/tooltip";
import Button from "antd/lib/button";
import Dropdown from "antd/lib/dropdown";
import Modal from "antd/lib/modal";
import Radio from "antd/lib/radio";
import Spin from "antd/lib/spin";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import type { MenuProps } from "antd/es/menu/menu";
import type { RadioChangeEvent } from "antd/es/radio";
//Icons
import FilePdfOutlined from "@ant-design/icons/FilePdfOutlined";
import FileWordOutlined from "@ant-design/icons/FileWordOutlined";
import FileExcelOutlined from "@ant-design/icons/FileExcelOutlined";
import FileJpgOutlined from "@ant-design/icons/FileJpgOutlined";
import UpOutlined from "@ant-design/icons/UpOutlined";
import DownOutlined from "@ant-design/icons/DownOutlined";
import CheckCircleOutlined from "@ant-design/icons/CheckCircleOutlined";
import FormOutlined from "@ant-design/icons/FormOutlined";
import SaveOutlined from "@ant-design/icons/SaveOutlined";
import checkBefore from '../../../../helpers/selectionOfActions';
import message from 'antd/lib/message';


// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
/**
 * Цей компонент відповідає за збереження файлів.
 */
export default function FileEditorComponent(props: FileEditorComponentProps) {
  const location = useLocation();
  const { intl } = useContext(TranslationContext);

  const typeDocMap: Record<string, number> = {
    "/documents/incoming": 1,
    "/documents/outcoming": 2,
    "/documents/internal": 3,
    "/documents/electronic-mail": 4,
  };
  const typeDocId = typeDocMap[location.pathname];

  const disabled = !(props.selectedFiles && props.selectedFiles.length > 0);
  const icon = typeDocId === 4;

  const mimeTypeMap: { [key: string]: string } = {
    ".txt": "text/plain",
    ".pdf": "application/pdf",
    ".doc": "application/msword",
    ".docx":
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".xls": "application/vnd.ms-excel",
    ".xlsx":
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".jpg": "image/jpg",
    ".jpeg": "image/jpeg",
    ".png": "image/png",
    ".bmp": "image/bmp",
  };

  interface FileData {
    uid: number;
    name: string;
    type: string;
    data: string;
    isSignature: boolean;
  }

  const saveFiles = async () => {

  //Компонент перевірка на доступ до внесення даних чи змін
  let accessRights = await checkBefore(location.pathname, undefined, 'save-files');
    if (!accessRights) {
      message.error(intl("you-do-not-have-access-rights"));
      return;
    }

    try {
      const response: { success: boolean; data: FileData[] } = await request(
        "/save/save-files",
        {
          method: "post",
          body: {
            id: props.bta_documents_id,
            page: location.pathname.split("/").pop(),
            filesId: props.selectedFiles?.join(", "),
          },
          cancelTokenKey: "savefiles",
        }
      );

      if (response.success && response.data) {
        response.data.forEach((file) => {
          const mimeType = mimeTypeMap[file.type] || "application/octet-stream";
          const byteArray = Uint8Array.from(atob(file.data), (c) =>
            c.charCodeAt(0)
          );
          const blob = new Blob([byteArray], { type: mimeType });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = file.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        });
      } else {
        console.error("Failed to fetch files from the server.");
      }
    } catch (error) {
      console.error("Error saving files:", error);
    }
  };

  return (
      <Button
          className={icon? styles["file-table-button"]: styles["file-list-button"]}
          onClick={saveFiles}
          disabled={disabled}
          icon={icon && <SaveOutlined />} 
          title={ icon ? intl("save-files"): undefined}
        >
          { !icon && intl("save-files")}
      </Button>
  );
}
